import React from "react";
import { X } from "lucide-react";

/** Title row with a close button for CustomModal content. */
const ModalHeader = ({ title, onClose }) => (
  <div className="flex justify-between items-start w-full gap-3">
    <h3 className="text-[1.125rem] font-semibold text-gray-800 dark:text-gray-100">{title}</h3>
    {onClose && (
      <button
        type="button"
        aria-label="Close"
        className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800"
        onClick={onClose}
      >
        <X size={20} className="text-gray-800 dark:text-gray-100" />
      </button>
    )}
  </div>
);

export default ModalHeader;
